import React, { createContext, ReactNode, useContext } from 'react';

const DarkThemeContext = createContext(false);

interface DarkThemeProviderProps {
  enabled: boolean;
  children: ReactNode;
}

export function DarkThemeProvider({
  enabled,
  children,
}: DarkThemeProviderProps) {
  return (
    <DarkThemeContext.Provider value={enabled}>
      {children}
    </DarkThemeContext.Provider>
  );
}

export function useIsDarkTheme(): boolean {
  return useContext(DarkThemeContext);
}
